import styled, { css } from 'styled-components';
import { skeleton } from 'src/components/skeleton';
import * as Layout from '../styles';
import * as WordGroup from '../WordGroup/styles';
import * as Actions from '../Actions/styles';

export const Screen = Layout.Screen;
export const HeaderSlot = Layout.HeaderSlot;
export const ScrollArea = Layout.ScrollArea;
export const Content = Layout.Content;
export const Hero = Layout.Hero;
export const HeroText = Layout.HeroText;
export const Results = Layout.Results;
export const Groups = Layout.Groups;
export const Footer = Layout.Footer;
export const GroupCard = WordGroup.Card;
export const GroupHeader = WordGroup.Header;
export const GroupList = WordGroup.List;
export const GroupRow = WordGroup.Row;
export const ActionsContainer = Actions.Container;

export const Bone = styled.div(
  ({ theme }) => css`
    border-radius: ${theme.bo.small};
    ${skeleton};
  `,
);

export const HeaderBar = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.sz.s4};
    padding: ${theme.sz.s3} ${theme.sz.s8};
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.primary90};

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s3} ${theme.sz.s4};
    }
  `,
);

export const LogoBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s28};
    height: ${theme.sz.s6};

    @media (max-width: ${theme.sz.md}) {
      display: none;
    }
  `,
);

export const HeaderActions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
  `,
);

export const HeaderPill = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s16};
    height: ${theme.sz.s8};
    border-radius: ${theme.bo.round};
  `,
);

export const ClipBone = styled(Bone)(
  ({ theme }) => css`
    flex-shrink: 0;
    width: ${theme.sz.s24};
    height: ${theme.sz.s24};
    border-radius: ${theme.bo.elliptical};

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s16};
      height: ${theme.sz.s16};
    }
  `,
);

export const TitleBone = styled(Bone)(
  ({ theme }) => css`
    width: min(100%, ${theme.sz.s48});
    height: ${theme.sz.s8};
    margin-bottom: ${theme.sz.s2};

    @media (max-width: ${theme.sz.md}) {
      height: ${theme.sz.s6};
    }
  `,
);

export const SubheaderBone = styled(Bone)(
  ({ theme }) => css`
    width: min(100%, ${theme.sz.s32});
    height: ${theme.sz.s4};
  `,
);

export const GroupTitleBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s24};
    height: ${theme.sz.s3};
  `,
);

export const GroupCountBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s4};
    height: ${theme.sz.s3};
  `,
);

export const FlowerBone = styled(Bone)(
  ({ theme }) => css`
    flex-shrink: 0;
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    border-radius: ${theme.bo.round};
  `,
);

export const WordLines = styled.div(
  ({ theme }) => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${theme.sz.s1};
    min-width: 0;
  `,
);

export const TargetBone = styled(Bone)<{ $width: string }>(
  ({ theme, $width }) => css`
    width: min(${$width}, ${theme.sz.s28});
    height: ${theme.sz.s4};
  `,
);

export const SourceBone = styled(Bone)(
  ({ theme }) => css`
    width: min(50%, ${theme.sz.s20});
    height: ${theme.sz.s3};
  `,
);

export const ButtonBone = styled(Bone)(
  ({ theme }) => css`
    width: 100%;
    height: ${theme.sz.s12};
    border-radius: ${theme.bo.round};
  `,
);

export const LinkBone = styled(Bone)(
  ({ theme }) => css`
    width: ${theme.sz.s28};
    height: ${theme.sz.s4};
  `,
);
